import { Directive, ElementRef, inject, input } from '@angular/core';
import type { OnDestroy, OnInit } from '@angular/core';
import type { AbstractControl } from '@angular/forms';

import { EvaluationFormSubmissionService } from '../services/evaluation-form-submission.service';

@Directive({
  selector: '[rtEvaluationFieldRef]',
})
export class EvaluationFieldRefDirective implements OnInit, OnDestroy {
  private readonly formSubmissionService = inject(EvaluationFormSubmissionService);

  public readonly elRef = inject(ElementRef);
  public readonly control = input.required<AbstractControl>({ alias: 'rtEvaluationFieldRef' });

  public ngOnInit(): void {
    this.formSubmissionService.registerField(this);
  }

  public ngOnDestroy(): void {
    this.formSubmissionService.unregisterField(this);
  }
}
